/**
 * package: com.inq.flash.client.control
 * class: FlashPeer
 * root Object
 * @constructor
 */
com.inq.flash.client.control.FlashPeer = function() {
};
$hxClasses['com.inq.flash.client.control.FlashPeer'] = com.inq.flash.client.control.FlashPeer;
/** @private @type {Array} */
com.inq.flash.client.control.FlashPeer.__name__ = ["com","inq","flash","client","control","FlashPeer"];

/**
 * FlashPeer.init
 * Implements mapping of obfuscated IJSF functions to CI
 * @param {Array} closureMap - contains links to IJSF functions.
 */
com.inq.flash.client.control.FlashPeer.init = function (closureMap) {
	com.inq.flash.client.control.FlashPeer.getConversationTranscript = closureMap[0];
	com.inq.flash.client.control.FlashPeer.getConversationObjectID = closureMap[1];
	com.inq.flash.client.control.FlashPeer.getConversationTokenID = closureMap[2];
};

/**
 * call - calls the function in the FlashPeer.js
 * if it does not exist, then the default value is passed back
 * if it throws, then the default value is passed back
 *
 * call is a private delegation routine that delegates to the "FlashPeer.js" file in the IJSF.
 *
 * @private
 * @static
 * @param {string}  funcName - string containing the function to be called in FlashPeer.js
 * @param {Array}  args - array of arguments to be applied the the method
 * @param {*} [deflt] - the default value if the function is not in "FlashPeer.js" or if it throws.
 * @return {*}
 */
com.inq.flash.client.control.FlashPeer.call = function (funcName, args, deflt) {
	if (com.inq.flash.client.control.FlashPeer.inqFlashPeer[funcName] == null) {
		haxe.Log.trace("window.Inq.FlashPeer." + funcName + " does not exist",{ fileName : "FlashPeer.hx", lineNumber : 25, className : "com.inq.flash.client.control.FlashPeer", methodName : "call"});
		return deflt;
	}
	try {
		return com.inq.flash.client.control.FlashPeer.inqFlashPeer[funcName].apply(com.inq.flash.client.control.FlashPeer.inqFlashPeer, args);
	} catch(e) {
		var argz = "";
		if (args) {
			for (var i = 0; i < args.length; i++) {
				argz += " arg[" + i + "] = " + args[i] + "\n";
			}
		}
		haxe.Log.trace("window.Inq.FlashPeer." + funcName + " failed: " + Std.string(e) + "\n" + argz,{ fileName : "FlashPeer.hx", className : "com.inq.flash.client.control.FlashPeer", methodName : "call"});
		return deflt;
	}
};

function define(funcName, deflt) {
	return function() {
		return com.inq.flash.client.control.FlashPeer.call(funcName, arguments, deflt);
	}
}

com.inq.flash.client.control.FlashPeer.acceptCobInvSafe = define("acceptCobSafe");
com.inq.flash.client.control.FlashPeer.acceptCobShareInv = define("acceptCobShare");
com.inq.flash.client.control.FlashPeer.applyAcifCommands = define("applyAcifCommands");
com.inq.flash.client.control.FlashPeer.blockService = define("blockTheService");
com.inq.flash.client.control.FlashPeer.captureEmailAddress = define("captureEmailAddress");
com.inq.flash.client.control.FlashPeer.closeChat = define("closeChat");
com.inq.flash.client.control.FlashPeer.closeChatMonitor = define("closeChatMonitor");
com.inq.flash.client.control.FlashPeer.closePersistent = define("closePersistent");
com.inq.flash.client.control.FlashPeer.closePersistentWindowIfOpen = define("closePersistentWindowIfOpen", null);
com.inq.flash.client.control.FlashPeer.closePopupChatFromPersistent = define("closePopupChatFromPersistent", null);
com.inq.flash.client.control.FlashPeer.createXFrame = define("createXFrame", null);
com.inq.flash.client.control.FlashPeer.endChatSession = define("endChatSession");
com.inq.flash.client.control.FlashPeer.endCob = define("endCob");
com.inq.flash.client.control.FlashPeer.endCobByEtlEvent = define("endCobByEtlEvent");
com.inq.flash.client.control.FlashPeer.executeCustomCommand = define("executeCustomCommand");
com.inq.flash.client.control.FlashPeer.debugLogErrorToTagServer = define("debugLogErrorToTagServer");
com.inq.flash.client.control.FlashPeer.debugLogDebugToTagServer = define("debugLogDebugToTagServer");
com.inq.flash.client.control.FlashPeer.debugLogInfoToTagServer = define("debugLogInfoToTagServer");
com.inq.flash.client.control.FlashPeer.debugLogWarnToTagServer = define("debugLogWarnToTagServer");
com.inq.flash.client.control.FlashPeer.debugSwitchForModule = define("debugSwitchForModule");
com.inq.flash.client.control.FlashPeer.fireConversationResolvedEvent = define("fireConversationResolvedEvent");
com.inq.flash.client.control.FlashPeer.fireCustomerAuthenticatedEvent = define("fireCustomerAuthenticatedEvent");
com.inq.flash.client.control.FlashPeer.fireVerifyTokenErrorEvent = define("fireVerifyTokenErrorEvent");
com.inq.flash.client.control.FlashPeer.fireVerifyTokenSuccessEvent = define("fireVerifyTokenSuccessEvent");
com.inq.flash.client.control.FlashPeer.fireCustomEvent = define("fireCustomEvent");
com.inq.flash.client.control.FlashPeer.fireCustomEvt = define("fireCustomEvt");
com.inq.flash.client.control.FlashPeer.fireNativeSurveyLaunchEvent = define("fireNativeSurveyLaunchEvent");
com.inq.flash.client.control.FlashPeer.getActiveChatroomId = define("getActiveChatroomId");
com.inq.flash.client.control.FlashPeer.getAgentGroupDisplayName = define("getAgentGroupDisplayName", null);
com.inq.flash.client.control.FlashPeer.getAgentGroupName = define("getAgentGroupName", null);
com.inq.flash.client.control.FlashPeer.getAgentID = define("getAgentID", null);
com.inq.flash.client.control.FlashPeer.getAuthenticatedUser = define("getAuthenticatedUser", null);
com.inq.flash.client.control.FlashPeer.getAutomatonDataMap = define("getAutomatonDataMap", null);
com.inq.flash.client.control.FlashPeer.getAutomatonDatapass = define("getAutomatonDatapass", null);
com.inq.flash.client.control.FlashPeer.getBaseURL = define("getBaseURL");
com.inq.flash.client.control.FlashPeer.getBrID = define("getBrID", null);
com.inq.flash.client.control.FlashPeer.getBrName = define("getBrName", null);
com.inq.flash.client.control.FlashPeer.getBrowserMajorVer = define("getBrowserMajorVer");
com.inq.flash.client.control.FlashPeer.getBrowserTypeAndVersion = define("getBrowserTypeAndVersion");
com.inq.flash.client.control.FlashPeer.getBuRuleAgentGroupID = define("getBuRuleAgentGroupID", null);
com.inq.flash.client.control.FlashPeer.getBusinessUnitDisplayName = define("getBusinessUnitDisplayName", null);
com.inq.flash.client.control.FlashPeer.getBusinessUnitID = define("getBusinessUnitID", null);
com.inq.flash.client.control.FlashPeer.getBusinessUnitName = define("getBusinessUnitName", null);
com.inq.flash.client.control.FlashPeer.getChatOwnerBusinessUnitID = define("getChatOwnerBusinessUnitID", null);
com.inq.flash.client.control.FlashPeer.getChatRouterVanityUrl = define("getChatRouterVanityUrl");
com.inq.flash.client.control.FlashPeer.getClientPageURL = define("getClientPageURL");
com.inq.flash.client.control.FlashPeer.getCobrowseEnableMinimizeRestore = define("getCobrowseEnableMinimizeRestore");
com.inq.flash.client.control.FlashPeer.getCustGeoData = define("getCustGeoData");
com.inq.flash.client.control.FlashPeer.getCustID = define("getCustID", null);
com.inq.flash.client.control.FlashPeer.getDeviceType = define("getDeviceType", null);
com.inq.flash.client.control.FlashPeer.getDisconnectionTimeout = define("getDisconnectionTimeout");
com.inq.flash.client.control.FlashPeer.getEmbeddedTheme = define("getEmbeddedTheme");
com.inq.flash.client.control.FlashPeer.getFileDeleteSetting = define("fileDeleteSetting", null);
com.inq.flash.client.control.FlashPeer.getFileTransferApiUrl = define("fileTransferApiUrl", null);
com.inq.flash.client.control.FlashPeer.getfileTransferExtensions = define("fileTransferExtensions", "jpg,jpeg,bmp,gif,png,doc,xls,docx,xlsx,pdf,txt");
com.inq.flash.client.control.FlashPeer.getFileTransferSize = define("fileTransferSize", null);
com.inq.flash.client.control.FlashPeer.getFileTransferUrl = define("fileTransferServerUrl", null);
com.inq.flash.client.control.FlashPeer.getChatSkinFmt = define("getChatSkinFmt");
com.inq.flash.client.control.FlashPeer.getFlashVars = define("getFlashVars");
com.inq.flash.client.control.FlashPeer.getFPSessionID = define("getFPSessionID", null);
com.inq.flash.client.control.FlashPeer.getImagePath = define("getImagePath");
com.inq.flash.client.control.FlashPeer.getIncAssignmentID = define("getIncAssignmentID", null);
com.inq.flash.client.control.FlashPeer.getInitialTimeout = define("getInitialTimeout");
com.inq.flash.client.control.FlashPeer.getIsBuilder = define("getIsBuilder", false);
com.inq.flash.client.control.FlashPeer.getIsSkinLocal = define("getIsSkinLocal", false);
com.inq.flash.client.control.FlashPeer.getLocalizedMessage = define("getLocalizedMessage");
com.inq.flash.client.control.FlashPeer.getMediaBaseURL = define("getMediaBaseURL");
com.inq.flash.client.control.FlashPeer.getMediaPath = define("getMediaPath", null);
com.inq.flash.client.control.FlashPeer.getPageID = define("getPageID", null);
com.inq.flash.client.control.FlashPeer.getPageMarker = define("getPageMarker", null);
com.inq.flash.client.control.FlashPeer.getPersistentCustomerID = define("getPersistentCustomerID", null);
com.inq.flash.client.control.FlashPeer.getPersistentHeight = define("getPersistentHeight");
com.inq.flash.client.control.FlashPeer.getPersistentWidth = define("getPersistentWidth");
com.inq.flash.client.control.FlashPeer.getPersistentXPos = define("getPersistentXPos");
com.inq.flash.client.control.FlashPeer.getPersistentYPos = define("getPersistentYPos");
com.inq.flash.client.control.FlashPeer.getPopupCloserWidth = define("getPopupCloserWidth");
com.inq.flash.client.control.FlashPeer.getQueueMessagingSpec = define("getQueueMessagingSpec", null);
com.inq.flash.client.control.FlashPeer.getQueueMessagingSpecId = define("getQueueMessagingSpecId", null);
com.inq.flash.client.control.FlashPeer.getSessionID = define("getSessionID", null);
com.inq.flash.client.control.FlashPeer.getSiteConstants = define("getSiteConstants");
com.inq.flash.client.control.FlashPeer.getSkin = define("getSkin");
com.inq.flash.client.control.FlashPeer.getSkinHeight = define("getSkinHeight");
com.inq.flash.client.control.FlashPeer.getSkinLeft = define("getSkinLeft");
com.inq.flash.client.control.FlashPeer.getSkinLocation = define("getSkinLocation");
com.inq.flash.client.control.FlashPeer.getSkinMXML = define("getSkinMXML", null);
com.inq.flash.client.control.FlashPeer.getSkinName = define("getSkinName", null);
com.inq.flash.client.control.FlashPeer.getSkinPath = define("getSkinPath", null);
com.inq.flash.client.control.FlashPeer.getSkinTop = define("getSkinTop");
com.inq.flash.client.control.FlashPeer.getSkinWidth = define("getSkinWidth");
com.inq.flash.client.control.FlashPeer.getSurveyAuxParams = define("getSurveyAuxParams");
com.inq.flash.client.control.FlashPeer.getTitleBarHeight = define("getTitleBarHeight");
com.inq.flash.client.control.FlashPeer.getV3Data = define("getV3Data");
com.inq.flash.client.control.FlashPeer.getVAList = define("getVAList", []);
com.inq.flash.client.control.FlashPeer.getVanityUrl = define("getVanityUrl");
com.inq.flash.client.control.FlashPeer.getVisitorAttributes = define("getVisitorAttributes", null);
com.inq.flash.client.control.FlashPeer.getXFormsDomain = define("getXFormsDomain", null);
com.inq.flash.client.control.FlashPeer.getClientStaticURL = define("getClientStaticURL", false);
com.inq.flash.client.control.FlashPeer.hideChat = com.inq.flash.client.control.FlashPeer.closeChat;
com.inq.flash.client.control.FlashPeer.isAdblockEnabled = define("isAdblockEnabled");
com.inq.flash.client.control.FlashPeer.isAsyncUnauthUser = define("isAsyncUnauthUser");
com.inq.flash.client.control.FlashPeer.isAutoFixPrechatSurvey = define("isAutoFixPrechatSurvey");
com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode = define("isCEAPIPostChatSurveyMode", false);
com.inq.flash.client.control.FlashPeer.isClickStreamSent = define("isClickStreamSent");
com.inq.flash.client.control.FlashPeer.isCobrowseEngaged = define("isCobEngaged", false);
com.inq.flash.client.control.FlashPeer.isCobrowseSharedControl = define("isCobShared", false);
com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid = define("isEmbeddedThemeValid");
com.inq.flash.client.control.FlashPeer.isHideJsonTranscriptMessages = define("isHideJsonTranscriptMessages");
com.inq.flash.client.control.FlashPeer.isLoggingDisabled = define("isLoggingDisabled", false);
com.inq.flash.client.control.FlashPeer.isMultiChatSupported = define("isMultiChatSupported");
com.inq.flash.client.control.FlashPeer.isOne2ManyChatEnabled = define("isOne2ManyChatEnabled", false);
com.inq.flash.client.control.FlashPeer.isPersistentChat = define("isPersistentChat");
com.inq.flash.client.control.FlashPeer.isPersistentWindow = define("isPersistentWindow");
com.inq.flash.client.control.FlashPeer.isPolishNotationEnabled = define("isPolishNotationEnabled", false);
com.inq.flash.client.control.FlashPeer.isPortal = define("isPortal", false);
com.inq.flash.client.control.FlashPeer.isThankYouEnabled = define("isThankYouEnabled");
com.inq.flash.client.control.FlashPeer.isV3C2CPersistent = define("isV3C2CPersistent");
com.inq.flash.client.control.FlashPeer.isV3Continue = define("isV3Continue", null);
com.inq.flash.client.control.FlashPeer.JSONParse = define("JSONParse", null);
com.inq.flash.client.control.FlashPeer.launchNativePostChatSurvey = define("launchNativePostChatSurvey");
com.inq.flash.client.control.FlashPeer.launchNativeSDK = define("launchNativeSDK");
com.inq.flash.client.control.FlashPeer.loadKMSlibraries = define("loadKMSlibraries", null);
com.inq.flash.client.control.FlashPeer.logError = define("logError");
com.inq.flash.client.control.FlashPeer.logInfo = define("logInfo");
com.inq.flash.client.control.FlashPeer.logErrorToServer = define("logErrorToServer");
com.inq.flash.client.control.FlashPeer.logInfoToServer = define("logInfoToServer");
com.inq.flash.client.control.FlashPeer.logWarningToServer = define("logWarningToServer");
com.inq.flash.client.control.FlashPeer.noJSHostingInTagserver = define("noJSHostingInTagserver", false);
com.inq.flash.client.control.FlashPeer.noV3FrameChat = define("noV3FrameChat", false);
com.inq.flash.client.control.FlashPeer.evaluateLegacySettings = define("evaluateLegacySettings");
com.inq.flash.client.control.FlashPeer.onAgentDataPass = define("onAgentDataPass");
com.inq.flash.client.control.FlashPeer.onAgentMsg = define("onAgentMsg");
com.inq.flash.client.control.FlashPeer.onAssisted = define("onAssisted");
com.inq.flash.client.control.FlashPeer.onBeforeChatClosed = define("onBeforeChatClosed");
com.inq.flash.client.control.FlashPeer.onChatLoaded = define("onChatLoaded");
com.inq.flash.client.control.FlashPeer.onChatMinimize = define("onChatMinimize");
com.inq.flash.client.control.FlashPeer.onChatroomReady = define("onChatroomReady");
com.inq.flash.client.control.FlashPeer.onChatShown = define("onChatShown");
com.inq.flash.client.control.FlashPeer.onCookiesCommitted = define("onCookiesCommitted");
com.inq.flash.client.control.FlashPeer.onCustomerMsg = define("onCustomerMsg");
com.inq.flash.client.control.FlashPeer.onEngaged = define("onEngaged");
com.inq.flash.client.control.FlashPeer.onInteracted = define("onInteracted");
com.inq.flash.client.control.FlashPeer.onQueueWaitMsg = define("onQueueWaitMsg");
com.inq.flash.client.control.FlashPeer.onVADataPass = define("onVADataPass");
com.inq.flash.client.control.FlashPeer.parseXFrameUrl = define("parseXFrameUrl", null);
com.inq.flash.client.control.FlashPeer.isValidHttpUrl = define("isValidHttpUrl");
com.inq.flash.client.control.FlashPeer.prefetchURL = define("prefetchURL");
com.inq.flash.client.control.FlashPeer.prepareDataAndSendDTEvent = define("prepareDataAndSendDTEvent");
com.inq.flash.client.control.FlashPeer.postRequestToIframeProxy = define("postRequestToIframeProxy");
com.inq.flash.client.control.FlashPeer.popOutChat = define("popOutChat");
com.inq.flash.client.control.FlashPeer.PushToFrameset = define("PushToFrameset");
com.inq.flash.client.control.FlashPeer.reinitializeChatWithNewId = define("reinitializeChatWithNewId", false);
com.inq.flash.client.control.FlashPeer.registerPersistentWindow = define("registerPersistentWindow", false);
com.inq.flash.client.control.FlashPeer.registerWDMClient = define("registerWDMClient");
com.inq.flash.client.control.FlashPeer.requestTranscript = define("requestTranscript");
com.inq.flash.client.control.FlashPeer.resetConversationManager = define("resetConversationManager");
com.inq.flash.client.control.FlashPeer.sendChatExit = define("sendChatExit");
com.inq.flash.client.control.FlashPeer.getFlagSendDataToTSWithoutIframe = define("getFlagSendDataToTSWithoutIframe");
com.inq.flash.client.control.FlashPeer.sendNetworkBackup = define("sendNetworkBackup");
com.inq.flash.client.control.FlashPeer.sendRequestToServer = define("sendRequestToServer");
com.inq.flash.client.control.FlashPeer.setActiveWindowId = define("setActiveWindowId");
com.inq.flash.client.control.FlashPeer.setAgentConfig = define("setAgentConfig");
com.inq.flash.client.control.FlashPeer.setCABeacon = define("setCABeacon");
com.inq.flash.client.control.FlashPeer.setAgentClosedChat = define("setAgentClosedChat");
com.inq.flash.client.control.FlashPeer.setAsyncChat = define("setAsyncChat");
com.inq.flash.client.control.FlashPeer.setCiFunction = define("setCiFunction", null);
com.inq.flash.client.control.FlashPeer.setClickStreamSent = define("setClickStreamSent");
com.inq.flash.client.control.FlashPeer.setDisconnectFlag = define("setDisconnectFlag");
com.inq.flash.client.control.FlashPeer.setDragable = define("setDragable");
com.inq.flash.client.control.FlashPeer.setEventDataForSurvey = define("setEventDataForSurvey", null);
com.inq.flash.client.control.FlashPeer.setPersistentWindowActive = define("setPersistentWindowActive");
com.inq.flash.client.control.FlashPeer.setResizable = define("setResizable");
com.inq.flash.client.control.FlashPeer.setSurveyAuxParams = define("setSurveyAuxParams");
com.inq.flash.client.control.FlashPeer.setV3Data = define("setV3Data");
com.inq.flash.client.control.FlashPeer.submitNativePostChatSurvey = define("submitNativePostChatSurvey");
com.inq.flash.client.control.FlashPeer.unregisterWDMClient = define("unregisterWDMClient");
com.inq.flash.client.control.FlashPeer.verifyToken = define("verifyToken");
com.inq.flash.client.control.FlashPeer.wasSaleAction = define("wasSaleAction", false);
com.inq.flash.client.control.FlashPeer.getRemoveJSInMessages = define("getRemoveJSInMessages");
// ------------- Use alphabetical order ----------------- //

/** @type {com.inq.flash.client.control.FlashPeer} */
com.inq.flash.client.control.FlashPeer.prototype.__class__ = com.inq.flash.client.control.FlashPeer;
/** @type {null} */
com.inq.flash.client.control.FlashPeer.inqFlashPeer = window['Inq']['FlashPeer'];
